import styled from '@emotion/styled';

export const AppContent = styled.div`
  background-color: white;
  height: calc(100% - 70px);
  display: flex;
  overflow-y: hidden;
`;

export const AppView = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
`;
